var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeetingRoomRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    fill: "#ea5050",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 41v-2.25h4.45V7H29.6v2.15h6.5v29.6h4.4V41h-6.65V11.45H29.6V41Zm6.7-31.75v29.5Zm8.7 16.5q.75 0 1.25-.5t.5-1.25q0-.75-.5-1.25t-1.25-.5q-.75 0-1.25.5t-.5 1.25q0 .75.5 1.25t1.25.5Zm-8.7 13h13.1V9.25H14.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingRoomRed);
export default __webpack_public_path__ + "static/media/meeting_room_red.e666631cd59768403c7ee2090f48f994.svg";
export { ForwardRef as ReactComponent };